module.exports = __webpack_public_path__ + "img/0008.d07e35c6.jpg";